/** Payment methods stored as integers on service_receipts.paymentMethod */
export const PAYMENT_METHODS = [
  { value: 0, label: "Cash" },
  { value: 1, label: "Visa" },
  { value: 2, label: "Master card" },
  { value: 3, label: "Discover" },
  { value: 4, label: "Amex" },
  { value: 5, label: "Check" },
  { value: 6, label: "Gift card" },
];

export const PAYMENT_METHOD_LABELS = Object.fromEntries(
  PAYMENT_METHODS.map(({ value, label }) => [value, label])
);

export function getPaymentMethodLabel(method) {
  if (method === null || method === undefined || method === "") {
    return "Unspecified";
  }
  return PAYMENT_METHOD_LABELS[method] ?? "Unspecified";
}
